import { Box } from '@mui/material';

import { ChartProvider } from '@/components/Chart/context/ChartContext';
import { DataHubHeader } from '@/features/DataHub/components/DataHubHeader';
import { DataHubSection } from '@/features/DataHub/components/DataHubSection';
import { AccordionProvider } from '@/features/DataHub/components/ExportDrawer/AccordionContext';
import FooterButtons from '@/features/DataHub/components/ExportDrawer/FooterButtons';
import { PreviewCard } from '@/features/DataHub/components/Preview/PreviewCard';
import { DATAHUB_SPACING_LG } from '@/features/DataHub/constants/ui';
import DataHubExport from '@/features/DataHub/modules/Export';
import { ExportType, ItemDetailsSection } from '@/features/DataHub/modules/Export/components/Cards';
import ExportSettings from '@/features/DataHub/modules/Export/components/ExportSettings';

export const ExportConfigView = ({ openKey }: { openKey: string }) => {
  return (
    <ChartProvider>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          justifyContent: 'space-between'
        }}
      >
        <DataHubSection
          scroll
          gap={DATAHUB_SPACING_LG}
          sx={{ p: DATAHUB_SPACING_LG }}
        >
          <DataHubHeader
            subtitle='Set up your export file'
            title='Export configuration'
          />
          <AccordionProvider key={openKey}>
            <ItemDetailsSection />
            <ExportType />
            <ExportSettings />
            <PreviewCard />
            <DataHubExport />
          </AccordionProvider>
        </DataHubSection>
        <FooterButtons />
      </Box>
    </ChartProvider>
  );
};
